import { DeliveryActionTypes } from '../actions';
import { DeliveryState } from '../initial.state';

export const DeliveryReducer = (state = new DeliveryState(), { type, payload }) => {
  switch (type) {
    case DeliveryActionTypes.GET_CURRENT_TABLE_INFO: {
      if (payload)
        return {
          ...state,
          paginatedResponse: payload,
        };
      return state;
    }

    case DeliveryActionTypes.UPDATE_ADDRESS_DATA: {
      return {
        ...state,
        paginatedResponse: {
          ...state.paginatedResponse,
          content: state.paginatedResponse.content.map(item =>
            item?.address?.deliveryPackageId === payload?.deliveryPackageId
              ? { ...item, address: payload }
              : item
          ),
        },
      };
    }

    case DeliveryActionTypes.PROCESS_ORDER: {
      return {
        ...state,
        paginatedResponse: {
          ...state.paginatedResponse,
          content: state.paginatedResponse.content.filter(item => item.id !== payload.id),
        },
      };
    }

    case DeliveryActionTypes.UPDATE_ORDER_DATA: {
      return {
        ...state,
        paginatedResponse: {
          ...state.paginatedResponse,
          content: state.paginatedResponse.content.map(item =>
            item.id === payload.id ? payload : item
          ),
        },
      };
    }

    case DeliveryActionTypes.BULK_ASSIGN_TRACKING: {
      return {
        ...state,
        bulkAssignResult: payload,
      };
    }

    case DeliveryActionTypes.RESET_BULK_ASSIGN_RESULT: {
      return {
        ...state,
        bulkAssignResult: null,
      };
    }

    case DeliveryActionTypes.GET_COURSES_BY_STATUS: {
      return {
        ...state,
        courseOptions: payload ?? [],
      };
    }

    default: {
      return state;
    }
  }
};
